import { SvgIcon } from "@mui/material";
import React from "react";

const IconFailure = (props: { style: React.CSSProperties }) => {
  return (
    <SvgIcon style={props.style} viewBox="0 0 150 150">
      <path
        d="M92.687 57.312L57.312 92.687"
        stroke="#C2363A"
        strokeWidth="12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M92.687 92.687L57.312 57.312"
        stroke="#C2363A"
        strokeWidth="12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M131.25 75C131.25 43.934 106.066 18.75 75 18.75C43.934 18.75 18.75 43.934 18.75 75C18.75 106.066 43.934 131.25 75 131.25C106.066 131.25 131.25 106.066 131.25 75Z"
        stroke="#C2363A"
        strokeWidth="12"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default IconFailure;
